<template>
  <div>
    <div class="pages-available">
      <div class="title">
        {{ $t('dash.inbox.available_users') }}
      </div>
      <div class="content">
        <div class="search-page">
          <vs-input
            v-model="userFilter"
            :class="{'input': true}"
            color="#B20564"
            class="inputx"
            icon-after="true"  icon="search"
            :placeholder="$t('dash.inbox.label.user_filter')"
          />
        </div>
        <ul>
          <li class="page" v-for="item in allUsers" :key="item.id"
                :class="[{'hide': !checkUserFilter(item), 'select': selectedToAdd.find(p => p.id == item.id) }]" @click="selectAvailable(item)">
            <div class="page-wrapper">
              <div class="page-content">
                <Tooltip :text="`${item.lastname} ${item.firstname} (${item.email})`" position="top">
                  <vs-avatar color="#f9f9f9" size="42px" v-if="!item.avatar || !item.avatar.length" :src="require('../../../assets/img/ico-man.svg')"/>
                  <vs-avatar v-else-if="item.avatar && !!item.avatar.length" :src="item.avatar"/>
                  <p class="page-name">{{ `${item.lastname} ${item.firstname} (${item.email})` }}</p>
                  &nbsp;
                </Tooltip>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="actions">
      <div class="all" @click="all" v-if="!unique">
        <img src="../../../assets/img/icon-RAZ.svg" alt="icon RAZ">
      </div>
      <div class="add" @click="add">
        <img src="../../../assets/img/icon-right-arrow.svg" alt="icon right arrow">
      </div>
      <div class="remove" @click="remove">
        <img src="../../../assets/img/icon-left-arrow.svg" alt="icon left arrow">
      </div>
      <div class="raz" @click="raz" v-if="!unique">
        <img src="../../../assets/img/icon-RAZ.svg" alt="icon RAZ">
      </div>
    </div>

    <div class="pages-affected">
      <div class="title">{{ $t(`dash.inbox.user_selected${unique ? '.unique' : ''}`) }}</div>
      <div class="content">
        <ul>
          <li class="page" v-for="(item, index) in users" :key="item.id"
                :class="[{'select': selectedToRemove.find(p => p.id == item.id) }]" @click="selectAffected(item)">
            <div class="page-wrapper">
              <div class="page-content">
                <Tooltip :text="`${item.lastname} ${item.firstname} (${item.email})`" position="top">
                  <vs-avatar color="#f9f9f9" size="42px" v-if="!item.avatar || !item.avatar.length" :src="require('../../../assets/img/ico-man.svg')"/>
                  <vs-avatar v-else-if="item.avatar && !!item.avatar.length" :src="item.avatar"/>
                  <p class="page-name">{{ `${item.lastname} ${item.firstname} (${item.email})` }}</p>
                  &nbsp;
                </Tooltip>
              </div>
              <div class="position">
                <div class="top" :class="[{'disable': index == 0}]" @click="changePosition(index, index-1)">
                  <img alt="top" class="hide-group" src="../../../assets/img/icon-hide-group.svg"/>
                </div>
                <div class="bottom" :class="[{'disable': index == users.length-1}]" @click="changePosition(index, index+1)">
                  <img alt="bottom" class="hide-group" src="../../../assets/img/icon-hide-group.svg"/>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="submit">
      <div class="option_validation" v-if="type == 'affected_to'">
        <div class="checkbox">
          <input
            type="checkbox"
            name="option_validation"
            v-model="optionValidation"
          >
          <span class="checkmark">
            <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
            <span class="material-icons">remove</span>
          </span>
        </div>
        {{ $t('dash.post.option_validation') }}
      </div>
      <vs-button 
        class="validate"
        @click="submit"
        color="#6a1f4c">
        <p>{{ $t('dash.pages.overlay.validate') }}</p>
      </vs-button> 
    </div>

  </div>
</template>

<script>

import Tooltip from '../tooltip/tooltipInit.vue'
import Settings from '../../mixins/Settings.vue';

export default {
  name: 'component-users-selector',

  mixins: [Settings],

  components: {
    Tooltip
  },

  props: {
    usersAdded: Array,
    unique: {type: Boolean, default: false},
    manager: {type: Boolean, default: false},
    type: String,
    editOptionValidation: Boolean,
  },

  // computed: {
  //   allUsers() {
  //     if(localStorage.users){
  //       if(this.manager){
  //         let currentUser = JSON.parse(localStorage.user)
  //         return JSON.parse(localStorage.users).filter(user => user.id != currentUser.id && (!user.role || (user.role && !(user.role.includes('Viewer') || user.role.includes('Writter')))))
  //       }
  //       return JSON.parse(localStorage.users)
  //     }
  //     return []
  //   }
  // },

  data() {
    return {
      users: [],
      userFilter: '',
      selectedToAdd: [],
      selectedToRemove: [],
      allUsers: [],
      optionValidation: true
    }
  },

  async mounted() {
    this.users = this.usersAdded && this.usersAdded.length ? this.usersAdded : []
    this.allUsers = localStorage.users && JSON.parse(localStorage.users) ? JSON.parse(localStorage.users) : []

    const usersResp = await this.listUsers({})
    if(usersResp && usersResp.body && usersResp.body.users) {
      localStorage.setItem('users', JSON.stringify(usersResp.body.users))
      this.allUsers = usersResp.body.users
    } 
    
    if(this.allUsers && this.allUsers.length){
      if(this.manager){
        let currentUser = JSON.parse(localStorage.user)
        // this.allUsers = this.allUsers.filter(user => user.id != currentUser.id && (!user.role || (user.role && !(user.role.includes('Viewer') || user.role.includes('Writter')))))
        this.allUsers = this.allUsers.filter(user => user.id != currentUser.id && (!user.role || (user.role && !user.role.includes('Writter'))))
      }
    }

    if(typeof this.editOptionValidation == "boolean")
      this.optionValidation = this.editOptionValidation
    else if(this.type == 'affected_to' && localStorage.optionValidation) {
      this.optionValidation = JSON.parse(localStorage.optionValidation)
    }
  },

  watch: {
    usersAdded() {
      this.users = this.usersAdded && this.usersAdded.length ? this.usersAdded : []
    }
  },

  methods: {
    
    checkUserFilter(user) {
        if(this.users.find(u => u.id == user.id))
          return false
        
        return user.firstname.toLowerCase().includes(this.userFilter.trim().toLowerCase()) 
                || user.lastname.toLowerCase().includes(this.userFilter.trim().toLowerCase()) 
                || user.email.toLowerCase().includes(this.userFilter.trim().toLowerCase()) 
    
    },

    changePosition(fromIndex, toIndex) {
      if(toIndex >= 0 && toIndex < this.users.length){
        let element = this.users[fromIndex];
        this.users.splice(fromIndex, 1);
        this.users.splice(toIndex, 0, element);
      }
    },

    selectAffected(page){
      this.selectedToAdd = []
      if(this.selectedToRemove.find(p => p.id == page.id))
        this.selectedToRemove = this.selectedToRemove.filter(p => p.id != page.id)
      else
        this.selectedToRemove.push(page)
    },
    
    selectAvailable(page){
      this.selectedToRemove = []
      if(this.unique && this.users.length >= 0) this.selectedToAdd = [page] 
      else if(this.selectedToAdd.find(p => p.id == page.id))
        this.selectedToAdd = this.selectedToAdd.filter(p => p.id != page.id)
      else
        this.selectedToAdd.push(page)
    },

    add() {
      if(this.unique && this.users.length > 0) return
      if(this.selectedToAdd.length) {        
        for(let user of this.selectedToAdd)
          this.users.unshift(user) 
        this.selectedToAdd = []
      }
    },

    remove() {
      if(this.selectedToRemove.length) {
        for(let user of this.selectedToRemove)
          this.users = this.users.filter(u => u.id != user.id)
        this.selectedToRemove = []
      }
    },

    raz() {
      this.users = []
    },

    all() {
      this.users = this.users.concat(this.allUsers.filter(item => this.checkUserFilter(item)))
    },

    submit() {
      if(this.type == 'affected_to') {
        localStorage.optionValidation = JSON.stringify(this.optionValidation)
      }
      this.$emit('submit', this.users, this.type == 'affected_to' ? this.optionValidation : null)
    }
  }
}
</script>
